import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-cookie',
  imports: [],
  templateUrl: './cookie.component.html',
  styleUrl: './cookie.component.scss',
})
export class CookieComponent implements OnInit, OnDestroy {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit(): void {
  if (isPlatformBrowser(this.platformId)) {
    const id = document.getElementById('ot-sdk-cookie-policy-container');
    if(id){
      id.style.display = 'block';
    }
  }
}


ngOnDestroy(): void {
  if (isPlatformBrowser(this.platformId)) {
    const id = document.getElementById('ot-sdk-cookie-policy-container');
    if(id){
      id.style.display = 'none';
    }
  }
}
}
